export default {
  sourceRatingImport: [],
  isLoading: false,
  error: null,
};
